import axios from 'axios';
import { history } from '../../history';
import * as registerActions from '../../actions/register-actions/register-actions';
import * as loginActions from '../../actions/login-actions/loginActions';
// import * as constants from '../../../constants/constants'
import { Auth } from 'aws-amplify';
const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT || 'https://apidmz.fpl.com';
// 'http://localhost:8080';
let API_KEY = process.env.REACT_APP_RTCP_API_KEY;

let authHeader =
  'Authorization, Origin, X-Requested-With, content-Type, Accept';
let REQUEST_TYPE = 'application/json';
export function register(payload) {
  console.log(payload);
  let email = payload.emailAddress;
  let password = payload.password;
  let username = payload.emailAddress;
  let firstName = payload.firstName;
  let lastName = payload.lastName;
  let companyName = payload.companyName;
  let street = payload.street;
  let streetLine2 = payload.streetline2;
  let city = payload.city;
  let state = payload.state;
  let zipCode = payload.zipCode;
  let phoneNumber = payload.phoneNumber;
  let url = payload.url;
  return dispatch => {
    dispatch(registerActions.setRemove());
    dispatch(registerActions.setRegisterPending(true));
    console.log(username);
    Auth.signUp({
      username,
      password,
      attributes: {
        email,
        'custom:firstName': firstName,
        'custom:lastName': lastName,
        'custom:companyName': companyName,
        'custom:street': street,
        'custom:streetLine2': streetLine2,
        'custom:city': city,
        'custom:state': state,
        'custom:zipCode': zipCode,
        'custom:phoneNumber': phoneNumber,
        'custom:companyWebSite': url,
      },
    })
      .then(response => {
        console.log('actions.register():', response);
        dispatch(registerActions.setRegistrationCode(false, response));
        axios
          .post(`${API_ENDPOINT}/v1/surety-bond/auth/sendConfirmCode`, '', {
            headers: {
              'Content-Type': REQUEST_TYPE,
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': authHeader,
              'Access-Control-Allow-Methods': '*',
              'Access-Control-Allow-Credentials': 'true',
              apikey: API_KEY,
              emailId: username,
            },
            crossorigin: true,
          })
          .then(response => {
            console.log('reset Password VerifyUser response', response);
            // dispatch(resetActions.setVerifyUserSuccess(false, response.data));
          })
          .catch(err => {
            console.log(err);
            dispatch(
              registerActions.setRegisterError(
                false,
                'Error in Sending the Verification Code ,Please try again later',
              ),
            );
          });
      })
      .catch(error => {
        console.log(error);
        if (error.code === 'UsernameExistsException') {
          // dispatch(registerActions.setRegisterError(false, error.message));
          dispatch(
            registerActions.setRegisterError(
              false,
              `Your account isn't confirmed! ` +
                'Please check your email to find the confirmation code.',
            ),
          );
          let data = {
            resend: true,
            email: username,
            error: `Your account isn't confirmed! 
                Please check your email to find the confirmation code.`,
          };
          history.push('/register', { data });
        } else if (error.code === 'UserNotConfirmedException') {
          dispatch(
            registerActions.setRegisterError(
              false,
              `Your account isn't confirmed! ` +
                'Please check your email to find the confirmation code.',
            ),
          );
        } else {
          dispatch(registerActions.setRegisterError(false, error.message));
        }
      });
  };
}

// Cognito - Auth.confirmSignUp()
export function confirmRegistration(user, code) {
  return dispatch => {
    dispatch(registerActions.setRemove());
    dispatch(registerActions.setRegisterPending(true));
    console.log('actions.confirmRegistration(): cognitoUSer, code:', {
      user,
      code,
    });
    let username = user;
    axios
      .post(`${API_ENDPOINT}/v1/surety-bond/auth/confirm-user-signup`, '', {
        headers: {
          'Content-Type': REQUEST_TYPE,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': authHeader,
          'Access-Control-Allow-Methods': '*',
          'Access-Control-Allow-Credentials': 'true',
          apikey: API_KEY,
          emailId: username,
          verificationtoken: code,
        },
        crossorigin: true,
      })
      .then(response => {
        console.log('resetPasswordVerifyUser response', response);
        dispatch(registerActions.setRegisterSuccess(false, response.data));
        dispatch(loginActions.reset());
        history.push('/login');
      })
      .catch(error => {
        console.error(
          'actions.confirmRegistration():Auth.confirmSignUp() err:',
          error,
        );
        dispatch(
          registerActions.setRegisterError(false, error.response.data.message),
        );
      });
  };
}

export function resendConfirmationCode(user) {
  return dispatch => {
    dispatch(registerActions.setRemove());
    dispatch(registerActions.setRegisterPending(true));
    console.log('actions.resendConfirmationCode(): cognitoUSer, code:', {
      user,
    });
    let username = user;
    axios
      .post(`${API_ENDPOINT}/v1/surety-bond/auth/createToken`, '', {
        headers: {
          'Content-Type': REQUEST_TYPE,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': authHeader,
          'Access-Control-Allow-Methods': '*',
          'Access-Control-Allow-Credentials': 'true',
          apikey: API_KEY,
          emailId: username,
        },
        crossorigin: true,
      })
      .then(response => {
        console.log('resetPasswordVerifyUser response', response);
        dispatch(registerActions.setRegistrationCode(false, response.data));
      })
      .catch(error => {
        dispatch(
          registerActions.setRegisterError(false, error.response.data.message),
        );
      });
  };
}

export function resetRegister() {
  return dispatch => {
    dispatch(registerActions.setReset());
  };
}

export function forgotUserName(attr) {
  // To initiate the process of verifying the attribute like 'phone_number' or 'email'
  Auth.verifyCurrentUserAttribute(attr)
    .then(() => {
      console.log('a verification code is sent');
    })
    .catch(e => {
      console.log('failed with error', e);
    });
}

export function forgotUserNameVerify(attr) {
  // To initiate the process of verifying the attribute like 'phone_number' or 'email'
  Auth.verifyCurrentUserAttributeSubmit(attr, 'the_verification_code')
    .then(() => {
      console.log('phone_number verified');
    })
    .catch(e => {
      console.log('failed with error', e);
    });
}
